import PageShell from "@/components/PageShell";

export default function TermsConditions() {
  return (
    <PageShell testid="terms-conditions-page" eyebrow="Legal" title="Terms & Conditions." updated="26 September 2026">
      <p>
        Welcome to www.frenchpie.co.in, operated by French Pie (Sahil &amp; Co), a sole proprietorship owned by Sahil
        Majid Dar ("we", "us"), Havells Galaxy, Sector 3, Shamasabad, Bemina, Srinagar, Jammu &amp; Kashmir 190018
        (GSTIN 01HBLPD9801F1ZX · FSSAI Reg. No. 21023418000068). By using this website or placing an order, you agree
        to these Terms &amp; Conditions. If you do not agree, please do not use the site.
      </p>

      <h2>1. Our services</h2>
      <p>
        We sell fresh bakery and pâtisserie products for dine-in, takeaway and website reservation with pickup at our
        Bemina outlet. Website reservations are requests for a pickup slot; the order is accepted when we confirm it
        (by email, phone or at the counter). Products are handcrafted, so the final bake may vary slightly from its
        photograph.
      </p>

      <h2>2. Pricing</h2>
      <ul>
        <li>All prices are in Indian Rupees (INR) and are inclusive of applicable taxes.</li>
        <li>The price shown at checkout is the price you pay — there are no hidden charges.</li>
        <li>Menu items are subject to availability; if an item sells out we will offer a substitute or a refund.</li>
      </ul>

      <h2>3. Payment</h2>
      <ul>
        <li>
          <strong>Cash on pickup</strong> — pay at the counter when collecting.
        </li>
        <li>
          <strong>Online payment</strong> — UPI, cards and wallets via Razorpay. Online payments are charged at the
          time of ordering and refunded to source if the order is cancelled as per our Refund &amp; Cancellation
          Policy.
        </li>
      </ul>

      <h2>4. Cancellation and pickup</h2>
      <p>
        You may cancel a reserved order until 9:00 PM on the day before pickup — see our Refund &amp; Cancellation
        Policy. Orders not collected by the end of the pickup day are treated as no-shows; perishable goods are not
        held beyond that.
      </p>

      <h2>5. Intellectual property</h2>
      <p>
        The French Pie name, logo, recipes, photography, text and site design are our property (or licensed to us)
        and may not be copied, reproduced or used commercially without our written permission. Personal, non-
        commercial use (sharing a photo, printing the menu) is welcome.
      </p>

      <h2>6. Termination</h2>
      <p>
        We may suspend or terminate your access to the website if you misuse it — for example, attempting fraud,
        abusing the order system, or breaching these terms. You may stop using the site at any time. Sections that
        by their nature survive (intellectual property, limitation of liability, governing law) survive termination.
      </p>

      <h2>7. Limitation of liability</h2>
      <p>
        The website is provided on an "as is" basis. To the maximum extent permitted by law, French Pie is not liable
        for indirect, incidental or consequential losses (including loss of profit or data) arising from your use of
        the website. Our total liability for any claim relating to an order is limited to the amount you paid for
        that order. Nothing limits liability that cannot be limited under applicable Indian law.
      </p>

      <h2>8. Governing law &amp; jurisdiction</h2>
      <p>
        These Terms are governed by the laws of India. Any dispute is subject to the exclusive jurisdiction of the
        courts at Srinagar, Jammu &amp; Kashmir.
      </p>

      <h2>9. Changes &amp; contact</h2>
      <p>
        We may update these Terms; the current version always lives on this page with its "Last updated" date.
        Questions: <strong>bemina@frenchpie.co.in</strong> · +91 95967 66336.
      </p>
    </PageShell>
  );
}
